'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCurrentUser = exports.fetchCurrentUser = exports.deserializeUser = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var countryCode = function countryCode(country) {
  switch (country) {
    case 'Australia':
      return 'AU';
    case 'United States':
      return 'US';
    case 'Ireland':
      return 'IE';
    case 'New Zealand':
      return 'NZ';
    case 'Hong Kong':
      return 'HK';
    case 'United Kingdom':
      return 'GB';
    default:
      return 'GB';
  }
};

var formattedAddress = function formattedAddress(_ref) {
  var line1 = _ref.line1,
      line2 = _ref.line2,
      townOrCity = _ref.townOrCity,
      countyOrState = _ref.countyOrState,
      postcodeOrZipcode = _ref.postcodeOrZipcode,
      country = _ref.country;
  return [line1, line2, townOrCity, countyOrState, postcodeOrZipcode, country].join(', ');
};

var deserializeUser = exports.deserializeUser = function deserializeUser(user) {
  return {
    address: user.address ? {
      streetAddress: user.address.line1,
      extendedAddress: user.address.line2,
      locality: user.address.townOrCity,
      state: user.address.countyOrState,
      postcode: user.address.postcodeOrZipcode,
      country: user.address.country
    } : {},
    birthday: null,
    country: user.country,
    countryCode: countryCode(user.country),
    email: user.email,
    firstName: user.firstName || user.given_name,
    formattedAddress: user.address ? formattedAddress(user.address) : null,
    id: user.accountId || user.justgiving_consumer_id,
    image: user.profileImageUrls && user.profileImageUrls.length ? user.profileImageUrls[0]['Value'] : 'https://assets.blackbaud-sites.com/images/supporticon/user.svg',
    lastName: user.lastName || user.family_name,
    name: user.name || [user.firstName, user.lastName].join(' '),
    pageCount: user.activePageCount,
    phone: null,
    uuid: user.userId || user.sub
  };
};

var fetchCurrentUser = exports.fetchCurrentUser = function fetchCurrentUser(_ref2) {
  var _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      _ref2$authType = _ref2.authType,
      authType = _ref2$authType === undefined ? 'Basic' : _ref2$authType;

  if (authType === 'Basic') {
    return (0, _client.get)('v1/account', {}, {}, {
      headers: {
        Authorization: [authType, token].join(' ')
      }
    });
  } else {
    return _client.jgIdentityClient.get('connect/userinfo', {
      headers: {
        Authorization: [authType, token].join(' ')
      }
    }).then(function (response) {
      return response.data;
    });
  }
};

var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser(_ref3) {
  var _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token,
      _ref3$uuid = _ref3.uuid,
      uuid = _ref3$uuid === undefined ? (0, _params.required)() : _ref3$uuid,
      _ref3$email = _ref3.email,
      email = _ref3$email === undefined ? (0, _params.required)() : _ref3$email,
      _ref3$authType = _ref3.authType,
      authType = _ref3$authType === undefined ? 'Basic' : _ref3$authType,
      firstName = _ref3.firstName,
      lastName = _ref3.lastName,
      _ref3$address = _ref3.address,
      address = _ref3$address === undefined ? {} : _ref3$address;
  return (0, _client.put)('v1/account/' + uuid, {
    firstName: firstName,
    lastName: lastName,
    email: email,
    address: {
      line1: address.line1 || address.streetAddress,
      line2: address.line2 || address.extendedAddress,
      townOrCity: address.townOrCity || address.locality,
      countyOrState: address.countyOrState || address.region,
      postcodeOrZipcode: address.postcodeOrZipcode || address.postCode,
      country: address.country
    }
  }, {
    headers: {
      Authorization: [authType, token].join(' ')
    }
  });
};